<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">环境监测设备</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="queryParams.equipmentName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <treeselect
              v-model="queryParams.areaCode"
              :options="regionDataTree"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="queryParams.onlineStatus" placeholder="请选择">
              <el-option key="" label="全部" value></el-option>
              <el-option key="" label="在线" value="1"></el-option>
              <el-option key="" label="离线" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
          >
            <el-table
              v-loading="loading"
              element-loading-text="加载中..."
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="equipmentName" label="设备名称"></el-table-column>
              <el-table-column prop="areaCodeTranslated" label="区域"></el-table-column>
              <el-table-column prop="categoryCodeTranslated" label="设备类型">
              </el-table-column>
              <el-table-column prop="longitude" label="经度" width="140">
              </el-table-column>
              <el-table-column prop="latitude" label="纬度" width="140">
              </el-table-column>
              <el-table-column prop="onlineStatus" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 1" style="color: green">在线</span>
                  <span v-if="scope.row.onlineStatus == 2" style="color: red">离线</span>
                </template>
              </el-table-column>
              <!-- fixed="right"  -->
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
//  getEquipmentCode, 
import { listEquipment, delEquipment, listEquipmentCategory } from "@/api/src/equipment";
// listEquipmentArea
import { listEquipmentAreaTree,  } from "@/api/src/equipmentArea";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "envdetectEquipmentView",
  controller: "UI",
  action: "envdetectEquipmentView",
  components: {
    Treeselect
  },
  data() {
    return {
     // 设备类型code
      code: 'env_detect',
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
          equipmentName: null,
          areaCode: null,
          pageNum: 1,
          pageSize: 10
      },
      // 表格数据
      tableData: [],
      // 设备类型数据
      equipmentTypeList:[],
      // 区域数据
      regionDataTree: [],
    };
  },
  created() {
    this.$nextTick(()=>{
      this.init();
      this.getAreaTree();
    });
  },
  mounted() {
    // this.search();
    // this.logInfo.ActionName = "SOS设备查询";
    // this.logInfo.LogMessage = "SOS设备查询";
    // this.logInfo.ModuleName = "设备管理";
    // this.logInfo.PageName = "SOS设备管理列表";
    // this.addOperationLog();
  },
  methods: {
    // 获取设备code
    init(){
      //  env_detect   sosEquipment
      // getEquipmentCode('env_detectEquipment').then(response =>{
        this.code = "env_detect";
        // this.code = response.data;
        this.queryParams.categoryCode = this.code;
        this.getList();
        // this.getEquipmentTypeList();
      // });
    },
    // 查询设备分类列表
    getEquipmentTypeList(){
      listEquipmentCategory({parentCode: this.code}).then(response =>{
        this.equipmentTypeList = this.handleTree(response.rows, "id", "pid");
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.categoryCode,
            label: obj.categoryName,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.equipmentTypeList = this.equipmentTypeList.map(obj => mapTree(obj));
      });
    },
    // 查询
    getList() {
      this.loading = true;
      this.queryParams.categoryCode = this.code;
      listEquipment(this.queryParams).then(response =>{
        this.tableData = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 查询区域-树
    getAreaTree(){
      listEquipmentAreaTree().then(response => {
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionDataTree = response.data.map(obj => mapTree(obj));
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击取消按钮
    onCancel() {
      this.resetForm("queryForm");
      this.queryParams.categoryCode = this.code;
      this.onSearch();
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/equipment/UI/SOSEquipmentInfo",
        query: { areaTree: this.regionDataTree, categoryCode: this.code, id: row.id, type: "edit"},
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/equipment/UI/SOSEquipmentInfo",
        query: { areaTree: this.regionDataTree, categoryCode: this.code, id: row.id, type: "query"},
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/SOSEquipmentInfo",
        query: { areaTree: this.regionDataTree, categoryCode: this.code, type: "add"},
      });
    },
  
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delEquipment(row);
      }).then(() => {
      this.$message({type: "success", message: "删除成功!"});
      this.getList();
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__menu{
  border-radius: 0px;
}
</style>